import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { SdfButton, SdfBox } from '@synerg/react-components';

export const ProjectHeader = (props = {}) => {
  const { projectListData } = props;

  const [projectHeaderData, setProjectHeaderData] = useState(projectListData);

  useEffect(() => {
    if (projectListData.createdDate === undefined) {
      getProjectHeaderDetails();
    } else setProjectHeaderData(projectListData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectListData]);

  const getProjectHeaderDetails = async () => {
    //projectName
    const { data: {projectsList} } = await axios.get(
      `${import.meta.env.VITE_ROOT_PATH}/api/partner/projects/search`,
      {
        params: {
          skip: 0,
          limit: 10,
          filterAppOrPartner: projectListData.projectName,
          orderByCreatedDate: -1,
        },
      }
    );
    const projectData =
      projectsList &&
      projectsList.find(
        (itx) => itx.projectName === projectListData.projectName
      );

    if (projectData) setProjectHeaderData(projectData);
  };

  //search-projects?skip=0&limit=10&filterAppOrPartner=dctest&orderByCreatedDate=-1

  const copyValues = (value) => {
    navigator.clipboard.writeText(value);
  };

  return (
    <SdfBox
      className="flex w-full pb-6 pt-6"
      variant="underlined"
      spacing="none"
    >
      <div className="w-full flex gap-5">
        <div className="w-1/12">
          <div
            className="text-sm overflow-ellipsis truncate"
            title="Partner name"
          >
            Partner name
          </div>
          <div
            className="text-md font-bold mt-2 overflow-ellipsis truncate"
            title={projectHeaderData.partnerOrgName}
          >
            {projectHeaderData.partnerOrgName}
          </div>
        </div>
        <div className="w-1/12">
          <div
            className="text-sm overflow-ellipsis truncate"
            title="Partner type"
          >
            Partner type
          </div>
          <div
            className="text-md font-bold mt-2 overflow-ellipsis truncate"
            title={projectHeaderData.partnerType || "NA"}
          >
            {projectHeaderData.partnerType || "NA"}
          </div>
        </div>
        <div className="w-1/12">
          <div
            className="text-sm overflow-ellipsis truncate"
            title="ADP product"
          >
            ADP product
          </div>
          <div
            className="text-md font-bold mt-2 overflow-ellipsis truncate"
            title={projectHeaderData.adpProduct || "NA"}
          >
            {projectHeaderData.adpProduct || "NA"}
          </div>
        </div>
        <div className="w-1/12">
          <div
            className="text-sm overflow-ellipsis truncate"
            title="Start date"
          >
            Start date
          </div>
          <div
            className="text-md font-bold mt-2 overflow-ellipsis truncate"
            title={projectHeaderData.createdDate || "NA"}
          >
            {projectHeaderData.createdDate || "NA"}
          </div>
        </div>
        <div className="w-2/12">
          <div className="text-sm overflow-ellipsis truncate" title="Use case">
            Use case
          </div>
          <div
            className="text-md font-bold mt-2 overflow-ellipsis truncate"
            title={projectHeaderData.caseDisplay || "NA"}
          >
            {projectHeaderData.caseDisplay || "NA"}
          </div>
        </div>
        <div className="w-1/12">
          <div
            className="text-sm overflow-ellipsis truncate"
            title="Marketplace"
          >
            Marketplace
          </div>
          <div
            className="text-md font-bold mt-2 overflow-ellipsis truncate"
            title={projectHeaderData.mkpllocal + " Marketplace"}
          >
            {projectHeaderData.mkpllocal + " Marketplace"}
          </div>
        </div>
        <div className="w-1/12">
          <div
            className="text-sm overflow-ellipsis truncate"
            title="Partner ID"
          >
            Partner ID
          </div>
          <div
            className="text-md font-bold mt-2 overflow-ellipsis truncate"
            title={projectHeaderData.isiOrgCd || "NA"} 
          >
            {projectHeaderData.isiOrgCd || "NA"}
          </div>
        </div>
        <div className="w-2/12">
          <div
            className="text-sm overflow-ellipsis truncate"
            title="Partner OOID"
          >
            Partner OOID
          </div>
          <div
            className="text-md font-bold mt-2 overflow-ellipsis truncate"
            title={projectHeaderData.partnerOOID || "NA"}
          >
            {projectHeaderData.partnerOOID || "NA"}
          </div>
        </div>
        <div className="w-2/12">
          <SdfButton
            className="py-3"
            variant="text"
            icon={"action-copy"}
            onClick={() => copyValues(projectHeaderData.partnerOOID)}
          >
            &nbsp;Copy OOID
          </SdfButton>
        </div>
      </div>
    </SdfBox>
  );
};
